import { ApplicationConfig, APP_INITIALIZER } from '@angular/core';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import {
  AutoRefreshTokenService,
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  includeBearerTokenInterceptor,
  provideKeycloak,
  UserActivityService,
  KeycloakService,
  withAutoRefreshToken,
} from 'keycloak-angular';
import { provideNativeDateAdapter } from '@angular/material/core';
import { environment } from '../environments/environment';
import { PermissionService } from './core/services/permission.service';
import { provideSelfService } from 'sigesr-self-service-lib';

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: environment.bearerPattern,
});

/**
 * Factory APP_INITIALIZER : lit le token dans le storage
 * et initialise le PermissionService AVANT que les composants se montent.
 * Cela évite un flash d'éléments non autorisés au chargement.
 */
function initPermissions(permissions: PermissionService): () => void {
  return () => permissions.initFromStorage();
}

export const appConfig: ApplicationConfig = {
  providers: [
    KeycloakService,

    provideKeycloak({
      config: environment.keycloakConfig,
      initOptions: {
        onLoad: 'check-sso',
        pkceMethod: 'S256',
        checkLoginIframe: false,
      },
      features: [
        withAutoRefreshToken({
          onInactivityTimeout: 'logout',
          sessionTimeout: 6000,
        }),
      ],
    }),

    AutoRefreshTokenService,
    UserActivityService,

    {
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [urlCondition],
    },

    // ← Initialise PermissionService depuis le storage au boot
    {
      provide: APP_INITIALIZER,
      useFactory: initPermissions,
      deps: [PermissionService],
      multi: true,
    },

    provideHttpClient(withXhr(), withInterceptors([includeBearerTokenInterceptor])),
    provideRouter(routes),
    provideNativeDateAdapter(),

    provideSelfService({
      passwordChange: {
        endpoint: `${environment.apiUrl}/users/me/change-password`,
        logoutCountdownMs: 5000
      }
    })
  ],
};